import React, { useState } from "react";
import ChatContainer from "./components/chat-container";
import { hamburger_menu } from "../../icons/hamburger-menu";
import { left_arrow } from "../../icons/left-arrow";
import Client from "../../utils/client";
import { api_url } from "../../constant";
import { useEffect } from "react";
import background from "../../images/Illustration.png";
import mobileBackground from "../../images/mobile-Illustration.png";
import ReactGA from "react-ga4";
import { Helmet } from "react-helmet";
import Consultation from "../../components/Consultation";
import { logActivity } from "../../api";



function MahsoolGuide() {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Mahsool Advisor",
  });
  const [question, setQuestion] = useState("");
  const [Response, setResponse] = useState("");
  const [oldConv, setOldConv] = useState("");
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");
  const [data, setData] = useState("");

  const isAuth = !!localStorage.getItem("token"); // or your existing auth logic

  useEffect(() => {
    logActivity("Visit Mahsool Advisor", "Page Visit", null, isAuth);
  }, []);

  useEffect(() => {
    const getConv = async () => {
      const response = await Client.get("/advisor/conversation").then(
        (res) => res.data
      );
      setData(response);
      if (response.length > 0) {
        setOldConv(response);
      } else {
        setOldConv([{ newUser: true }]);
      }
    };
    getConv();
  }, [Response]);

  const handleChange = (e) => {
    setQuestion(e.target.value);
  };

  const send = async () => {
    if (!question || question === null) {
      return;
    } else {
      setSending(true);
      await Client.post(
        api_url + "/advisor/question",
        { question },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
        .then(
          (res) => (setResponse(res.data), setSending(false), setQuestion(""))
        )
        .catch(
          (err) => (setError(err.response.data), err ? setSending(false) : "")
        );
    }
  };

  return (
    <div className="w-full h-full relative  mt-10">
      <Helmet>
        ‍<title>مرشد محصول - محصول</title>‍
        <meta property="og:site_name" content="Mahsool" />
        <meta name="keywords" content="Mahsool" />
        <meta property="og:title" content="مرشد محصول - محصول" />
        <meta property="og:description" content="mahsool" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className="mx-auto text-center lg:w-[66%] lg:border-2 border-primary rounded-2xl py-4 px-6 lg:px-10 bg-white">
        <div className="lg:pb-6 pb-4 flex-wrap flex gap-4 items-center justify-center lg:justify-between border-b-2 border-primary">
          <p className="text-4xl font-bold md:hidden">مرشد محصول</p>
          <Consultation />
          <p className="text-4xl font-bold md:block hidden">مرشد محصول</p>

          <div className="flex  justify-center lg:justify-end items-center gap-1">
            <div
              className={`text-white  rounded-full w-7 h-7 p-1 ${Math.ceil(data.length / 2) >= 30
                  ? "bg-orange-400"
                  : " bg-primary"
                }`}
            >
              <p className="h-full flex justify-center items-center">
                {data ? (
                  30 - Math.ceil(data.length / 2) >= 0 ? (
                    30 - Math.ceil(data.length / 2)
                  ) : (
                    0
                  )
                ) : (
                  <span className="bg-white/50 animate-pulse w-full h-full rounded-full"></span>
                )}
              </p>
            </div>
            <span className="text-sm font-bold">
              المتبقي من الباقة المجانية
            </span>
          </div>
        </div>
        <div className=" my-6 ">
          <ChatContainer
            data={oldConv}
            status={sending}
            query={question}
            isFetching={[]}
            error={error}
          />
        </div>
        <div className="relative w-full">
          <div className="h-16 border border-primary  rounded-2xl lg:flex px-3 lg:px-8 hidden lg">
            <button onClick={send} disabled={sending || oldConv.length >= 60}>
              {left_arrow}
            </button>
            <input
              disabled={sending || oldConv.length >= 60}
              type="text"
              dir="rtl"
              name="question"
              value={question}
              onKeyUp={(e) => e.key === "Enter" && send()}
              onChange={handleChange}
              placeholder="  إكتب إستفسارك..."
              className=" border-0  bg-transparent w-full focus:ring-0 text-gray-800 font-bold p-0 placeholder:text-base placeholder:text-gray-500 placeholder:font-medium "
            />
          </div>
          <div className="h-16 border absolute z-50 border-primary w-full rounded-2xl flex px-3 lg:px-8 lg:hidden">
            <button onClick={send} disabled={sending || oldConv.length >= 60}>
              {left_arrow}
            </button>
            <input
              disabled={sending || oldConv.length >= 60}
              type="text"
              dir="rtl"
              name="question"
              value={question}
              onChange={handleChange}
              placeholder="  إكتب إستفسارك..."
              className=" border-0  bg-transparent w-full focus:ring-0 text-gray-800 font-bold p-0 placeholder:text-base placeholder:text-gray-500 placeholder:font-medium "
            />
          </div>
        </div>
      </div>
      <div className="absolute -bottom-28 right-0 hidden lg:block">
        <img src={background} alt="" />
      </div>
      <div className="absolute z-0 -bottom-[6.5rem] right-0 lg:hidden ">
        <img src={mobileBackground} alt="" />
      </div>
    </div>
  );
}

export default MahsoolGuide;
